export const ASSISTANT_COLOR_INTERACTIVE = '#4858DE'
export const ASSISTANT_COLOR_TONAL = '#F1F2FC'

export const ASSISTANT_GRADIENT = 'linear-gradient(90deg, #4858DE 0%, #1FA4CC 50%, #AAE887 100%)'

export const ASSISTANT_ELEVATION_SHADOW_CLASS = 'shadow-[2px_0_4px_0_rgba(170,232,135,0.25),4px_0_4px_0_rgba(31,164,204,0.25),0_4px_4px_0_rgba(75,88,211,0.25)]'

export const ASSISTANT_FAB_INTRO_STORAGE_KEY = 'booksy-assistant-fab-intro-done'

export const ASSISTANT_FAB_INTRO_DURATION_MS = 10_000

export const ASSISTANT_FAB_SHRINK_ANIMATION_MS = 500

/** Matches calendar add-button visual size (48×48). */
export const ASSISTANT_FAB_SIZE_PX = 48

export const ASSISTANT_FAB_LABEL_COLOR = '#151618'

/** Default fixed position for the assistant FAB (1.25rem). */
export const ASSISTANT_FAB_BOTTOM_CLASS = 'bottom-5'

/** Stack above a page FAB on routes like calendar or customers (6.5rem). */
export const ASSISTANT_FAB_STACKED_BOTTOM_CLASS = 'bottom-[6.5rem]'

/** Align with page FABs at right 1.25rem + 0.5rem padding (1.75rem). */
export const ASSISTANT_FAB_RIGHT_CLASS = 'right-7'

/** Mobile top bar height matches `--sidebar-width` (3.5rem). */
export const ASSISTANT_OVERLAY_TOP_CLASS = 'top-14'

export const ASSISTANT_THEME_CLASSES = {
  textInteractive: 'text-[#4858DE]',
  bgInteractive: 'bg-[#4858DE]',
  bgTonal: 'bg-[#F1F2FC]',
  borderInteractive: 'border-[#4858DE]',
  ringInteractive: 'ring-[#4858DE]',
  hoverTonal: 'hover:bg-[#F1F2FC]',
  focusRing: 'focus-visible:ring-[#4858DE]',
} as const
